import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'dashboard-cards',
  templateUrl: './dashboard-cards.component.html',
  styleUrls: ['./dashboard-cards.component.scss']
})
export class DashboardCardsComponent implements OnInit {
  @Input() options: any = {
    icon: '',
    title: '',
    slogen: '',
    count:'',
    type:''
  }
  @Input() width = '75px';
  @Input() marginTop = 'unset';
constructor() { }

ngOnInit() {
}

}
